import React from 'react';
import A from './componentsNA/A';
// import B from './componentsNA/B';
import C from './componentsNA/C';
import D from './componentsNA/D';
import E from './componentsNA/E';
import F from './componentsNA/F';
import G from './componentsNA/G';
import H from './componentsNA/H';
import I from './componentsNA/I';
import J from './componentsNA/J';
import K from './componentsNA/K';
import L from './componentsNA/L';
import M from './componentsNA/M';
import N from './componentsNA/N';
import css from './NA.module.scss';
// import { useProductStore } from '@elem/compPage/rapid-mag-power-bank/ProductProvider';
// import { IPageStatus } from '@elem/compPage/rapid-mag-power-bank/config/IPageStatus';

const NA: React.FC = ({}) => {
    // const { pageStatus } = useProductStore();
    return (
        <div className={`page-product ${css.pageProduct}`}>
            <A />
            {/* {pageStatus !== IPageStatus.statusD && <B />} */}
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            <M />
            <N />
        </div>
    );
};
export default NA;
